import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from 'axios';
import {token, domain} from './../Security';
import {CreateTableForEmployeeSelect} from './../ManageTable';
import loadingSpinner from './../../assets/loading.gif';
import {useTable} from 'react-table';
import {globalTimeFormat} from './../Security';
// icon
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UploadIcon from '@mui/icons-material/Upload';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ListIcon from '@mui/icons-material/List';

function DTRCorrection({user, userAccess, isHideSideMenu}) {
    var header = [
        "Time In",
        "Time Out",
        "Location",
        ""
    ]
    var accessor = [
        "itineraryTimeIn",
        "itineraryTimeOut",
        "itineraryLocation",
        "manage"
    ]

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [itineraryList, setItineraryList] = useState([]);
    const [employee, setEmployee] = useState(user.employeePersonalInformationFullName);
    const [employeeId, setEmployeeId] = useState(user.employeePersonalInformationId);
    const [date, setDate] = useState("");
    const [timeType, setTimeType] = useState("");
    const [timeRendered, setTimeRendered] = useState("");
    const [timeRenderedNoIn, setTimeRenderedNoIn] = useState("");
    const [timeRenderedNoOut, setTimeRenderedNoOut] = useState("");
    const [reason, setReason] = useState("");
    const [files, setFiles] = useState([]);

    const [showVieHistoryForm, setShowVieHistoryForm] = useState(false);

    const [itineraryTimeIn, setItineraryTimeIn] = useState("");
    const [itineraryTimeOut, setItineraryTimeOut] = useState("");
    const [itineraryLocation, setItineraryLocation] = useState("");
    const [isItinerayAddState, setIsItinerayAddState] = useState(false);
    const [isItinerayUpdateState, setIsItinerayUpdateState] = useState(false);
    const [isItinerayDeleteState, setIsItinerayDeleteState] = useState(false);
    
    const [locationData, setLocationData] = useState([]);

    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const dtrCorrectionUrl =  domain + "/api/ChangeLogRequest";

    const fetchDataLocation = useCallback(async () => {
        const apiUrl =  domain + "/api/Location/active";
        setLoading(true);
        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }
        })
            setLocationData(response.data); // Set the response data to the state
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDataLocation();
    }, [fetchDataLocation]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const getFormattedDate = () => {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}T00:00`;
            return formattedDate;
        };

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(files.length > 0){
            base64String = await toBase64(files[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const uploadImage = files ? photoToBeSave : null;
        
        const _changeLogItineraries = itineraryList.map(item => ({
            changeLogRequestId: item.id,
            timeIn: item.itineraryTimeIn, // Replace this with actual date/time if available
            timeOut: item.itineraryTimeOut,// Replace this with actual date/time if available
            location: item.itineraryLocation
        }));

        const data = {
            employeePersonalInformationId: employeeId,
            approverId: null,
            requestTypeId: 4, // 3 is Change Log Request
            reason: reason,
            reasonForRejection: null,
            status: "Sent",
            dateRequested: getFormattedDate(),
            dateCompleted: getFormattedDate(),
            content: uploadImage,
            date: date,
            timeRendered: timeRendered,
            timeType: timeType,
            changeLogItineraries: _changeLogItineraries
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            const response = await axios.post(dtrCorrectionUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await sendSms(response.data);
            await createApproval(response.data)

            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Data added successfully');

            // Reload table data and reset form fields
            setDate("");
            setTimeType("");
            setTimeRendered("");
            setReason("");
            setFiles("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleSubmitNoInOut = async (event) => {
        event.preventDefault();
        setLoadingRequest(true);
    
        const getFormattedDate = () => {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}T00:00`;
        };
    
        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let photoToBeSave = files.length > 0 ? await toBase64(files[0]).then(res => res.split(',')[1]) : null;
    
        const _changeLogItineraries = itineraryList.map(item => ({
            changeLogRequestId: item.id,
            timeIn: item.itineraryTimeIn,
            timeOut: item.itineraryTimeOut,
            location: item.itineraryLocation
        }));
    
        const generateRequestData = (timeRendered, timeType) => ({
            employeePersonalInformationId: employeeId,
            approverId: null,
            requestTypeId: 4,
            reason,
            reasonForRejection: null,
            status: "Sent",
            dateRequested: getFormattedDate(),
            dateCompleted: getFormattedDate(),
            content: photoToBeSave,
            date: date,
            timeRendered: timeRendered,
            timeType: timeType,
            changeLogItineraries: _changeLogItineraries
        });
    
        const sendRequest = async (data) => {
            try {
                const response = await axios.post(dtrCorrectionUrl, data, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                await sendSms(response.data);
                await createApproval(response.data);
                setShowRequestMessage(true);
                setIsSuccess(true);
                console.log('Data added successfully');
            } catch (error) {
                setShowRequestMessage(true);
                setIsSuccess(false);
                const errorMessage = JSON.parse(error.response.request.responseText).message;
                setRequestMessage(errorMessage);
                console.error('Error:', error);
            }
        };
    
        // Send data for both in and out requests
        await sendRequest(generateRequestData(timeRenderedNoIn, "In"));
        await sendRequest(generateRequestData(timeRenderedNoOut, "Out"));
    
        // Reset form state
        setDate("");
        setTimeRenderedNoIn("");
        setTimeRenderedNoOut("");
        setReason("");
        setFiles("");
        setLoadingRequest(false);
    };
    const createApproval = async (dataToAdd) => {
        const apiUrl =  domain + "/api/Approval";

        const data = {
            requestId: dataToAdd.id,
            requestTypeId: dataToAdd.requestTypeId,
            primaryApproverId: null,
            primaryApproverUpdateDate: null,
            primaryApproverStatus: "Pending",
            secondaryApproverId: null,
            secondaryApproverUpdateDate: null,
            secondaryApproverStatus: "Pending",
            tertiaryApproverId: null,
            tertiaryApproverUpdateDate: null,
            tertiaryApproverStatus: "Pending",
        };

        try {
            await axios.post(apiUrl + `/${0}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log("create approval success")
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }
    const closeUploadFormHandleClick = () => {
        setShowUploadForm(false);
    }
    const handleFileUpload = () => {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("This is undermaintenance");
    }
    const addHandleClick = () =>{
        setIsItinerayAddState(true);
    }

    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(timeType === "NoInOut"){
            if (!employee || 
                !timeType ||
                !date ||
                !timeRenderedNoIn ||
                !timeRenderedNoOut
                ) {
                setErrorState(true);
                return;
            }
        } else {
            if (!employee || 
                !timeType ||
                !date ||
                !timeRendered
                ) {
                setErrorState(true);
                return;
            }
        }
    
        const renderedTime = `${date}T${timeRendered}`;
        const currentTime = new Date(); // Get current date and time

        // Convert renderedTime to a Date object
        const renderedDateTime = new Date(renderedTime);

        if (renderedDateTime > currentTime) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Unable to file DTR correction for a future date or time");
            
            return;
        }

        if(timeType !== "NoInOut"){
            handleSubmit(e);
        } else {
            handleSubmitNoInOut(e);
        }

        setErrorState(false);
    };

    const openViewHistoryForm = () => {
        setShowVieHistoryForm(true);
    }
    const closeViewHistoryForm = () => {
        setShowVieHistoryForm(false);
    }

    // for upload
    const handleBrowse = async (e) => {
        const fileList = Array.from(e.target.files);

        if (fileList.length > 0) {
        if (!fileList[0].type.startsWith("image/")) {
            alert("Please select an image file.");
            setFiles("");
            return;
        }

        const compressed = await compressImage(fileList[0]);
        setFiles([compressed]);
        }
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        if (fileList.length > 0) {
        if (!fileList[0].type.startsWith("image/")) {
            alert("Please select an image file.");
            setFiles("");
            return;
        }

        const compressed = await compressImage(fileList[0]);
        setFiles([compressed]);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };

    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };

    const clearFiles = () => {
        setFiles([]);
        document.getElementById("fileInput").value = "";
    };

    // 🔽 Utility: compress image to ~100KB
    const compressImage = (file, maxSizeKB = 100) => {
        return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // scale down to smaller size (e.g. half)
            const scale = Math.sqrt(maxSizeKB * 1024 / file.size);
            const width = img.width * scale;
            const height = img.height * scale;

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            let quality = 0.9;
            let dataUrl = canvas.toDataURL("image/jpeg", quality);

            // Loop: reduce quality until under target size
            while (dataUrl.length / 1024 > maxSizeKB && quality > 0.1) {
                quality -= 0.05;
                dataUrl = canvas.toDataURL("image/jpeg", quality);
            }

            // Convert back to File
            fetch(dataUrl)
                .then((res) => res.blob())
                .then((blob) => {
                const newFile = new File([blob], file.name, { type: "image/jpeg" });
                resolve(newFile);
                });
            };
        };
        });
    };

    //send sms
    const fetchDataApproverById = useCallback(async () => {
        const apiUrl =  domain + "/api/ApproverHierarchy";

        try {
            const response = await axios.get(apiUrl + `/${user.employeePersonalInformationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);
    const fetchDataEmployeesById = useCallback(async (id) => {
        const apiUrl = domain +"/api/Employee";

        try {
            const response = await axios.get(apiUrl + `/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const getApproverContact = async () =>{
        const formatPhoneNumber = (number) => {
            // Remove all dashes
            const cleanedNumber = number.replace(/-/g, '');
        
            // Check if the number starts with '0' and remove it
            const formattedNumber = cleanedNumber.startsWith('0') 
                ? '+63' + cleanedNumber.slice(1) 
                : '+63' + cleanedNumber;
        
            return formattedNumber;
        };

        const myApprover = await fetchDataApproverById();
        // const employeesInfo = await fetchDataEmployeesById();
        let approverNumbers = [];

        if(myApprover.primaryApprover){
            if(myApprover.primaryApprover.primaryApprover1Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover1Id,
                        fullName: myApprover.primaryApprover.primaryApprover1FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover2Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover2Id,
                        fullName: myApprover.primaryApprover.primaryApprover2FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover3Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover3Id,
                        fullName: myApprover.primaryApprover.primaryApprover3FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover4Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover4Id,
                        fullName: myApprover.primaryApprover.primaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.secondaryApprover){
            if(myApprover.secondaryApprover.secondaryApprover1Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover1Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover1FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover2Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover2Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover2FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover3Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover3Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover3FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover4Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover4Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.tertiaryApprover){
            if(myApprover.tertiaryApprover.tertiaryApprover1Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover1Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover1FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover2Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover2Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover2FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover3Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover3Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover3FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover4Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover4Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover4FullName
                    });
                }
            }
        }

        return approverNumbers;
    }
    const sendSms = async (data) => {
        const formattedNumber = data.referenceNumber.toString().padStart(6, '0');
        const contacts = await getApproverContact();

        if(contacts.length <= 0){
            return;
        }

const composeMessage = 
`Hello,

${employee} filed an DTR Correction Request. 

Please check reference number CH-${formattedNumber} in the portal.`
;
        
        for (const contact of contacts) {
            const smsData = {
                requestTypeId: 4,
                date: new Date(),
                senderId: user.employeePersonalInformationId,
                senderFullName: user.employeePersonalInformationFullName,
                message: composeMessage,
                recipientId: contact.id,
                recipientFullName: contact.fullName,
                recipientMobileNumber: contact.phoneNumber // phoneNumber
            }

            try {
                const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms', smsData); // euro asia
                // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
                console.log(response, `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
            } catch (error) {
                console.error(`Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`, error);
                console.log(`Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
            }
        }
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                <div className="TransactionInfo Transaction-Form-Info shadow-xl">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"DTR Correction"}</span>
                        </div>
                        <div className='row' style={{alignItems:"center", justifyContent:"space-between"}}>
                            <h3>DTR Correction</h3>
                            <div className="transaction-form-upper row" style={{display: "none"}}>
                                {CreateButton("overtime-add-button", "upload row", (e)=>setShowUploadForm(true), "UPLOAD", UploadIcon)}
                                {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                            </div>
                            <div className="transaction-form-upper row">
                                {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                            </div>
                        </div>
                        </div>
                        <div className="transaction-body">
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Employee</h4></div>
                                        <div className="transaction-form-input">
                                            <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                                <input
                                                    readOnly
                                                    className='employeeInput-select'
                                                    placeholder="Employee"
                                                    value={employee ? (employee) : employee}
                                                />
                                                <button className="select row"
                                                        onClick={()=>setShowEmployeeForm(true)}
                                                        style={{visibility: 
                                                            userAccess.description === "Admin" 
                                                            || userAccess.description === "HR Head" 
                                                            || userAccess.description === "HR Assistant" 
                                                            || userAccess.description === "HR Assistant2" 
                                                            || userAccess.description === "HR Assistant3" 
                                                            || userAccess.description === "HR Manager" 
                                                            ? "visible" : "hidden"}}
                                                ><SearchIcon/></button>
                                            </div>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !employee && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Time Type</h4></div>
                                        <div className="transaction-form-input">
                                            <TimeTypeSelect timeType={timeType} setTimeType={setTimeType}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !timeType && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Date</h4></div>
                                        <div className="transaction-form-input">
                                            <DateInput date={date} setDate={setDate}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !date && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                {   timeType !== "NoInOut" ?
                                    <div className='column' style={{width:"100%"}}>
                                        <div className="transaction-form-item row">
                                            <div className="transaction-form-category"><h4>Time Requested</h4></div>
                                            <div className="transaction-form-input">
                                                <TimeInput date={timeRendered} setDate={setTimeRendered}/>
                                            </div>
                                        </div>
                                        <span style={{
                                                marginTop:"-10px",
                                                display:"flex",
                                                justifyContent:"center",
                                                visibility: !timeRendered && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                    </div>

                                    :
                                    <div className='column' style={{width:"100%"}}>
                                        <div className='column' style={{width:"100%"}}>
                                            <div className="transaction-form-item row">
                                                <div className="transaction-form-category"><h4>Time Requested In</h4></div>
                                                <div className="transaction-form-input">
                                                    <TimeInput date={timeRenderedNoIn} setDate={setTimeRenderedNoIn}/>
                                                </div>
                                            </div>
                                            <span style={{
                                                    marginTop:"-10px",
                                                    display:"flex",
                                                    justifyContent:"center",
                                                    visibility: !timeRenderedNoIn && errorState ? "visible" : "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>Please fill up this field
                                            </span>
                                        </div>
                                        <div className='column' style={{width:"100%"}}>
                                            <div className="transaction-form-item row">
                                                <div className="transaction-form-category"><h4>Time Requested Out</h4></div>
                                                <div className="transaction-form-input">
                                                    <TimeInput date={timeRenderedNoOut} setDate={setTimeRenderedNoOut}/>
                                                </div>
                                            </div>
                                            <span style={{
                                                    marginTop:"-10px",
                                                    display:"flex",
                                                    justifyContent:"center",
                                                    visibility: !timeRenderedNoOut && errorState ? "visible" : "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>Please fill up this field
                                            </span>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                    <div className="transaction-form-category"><h4>Reason</h4></div>
                                    <div className="transaction-form-input">
                                        <textarea id="dtrCorrection-tamper"
                                            style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                        />
                                    </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                <div className="transaction-form-category"><h4>Upload</h4></div>
                                <div className="transaction-form-input">
                                    <label htmlFor="fileInput" className='browse'>Browse...</label>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        onChange={(e)=> handleBrowse(e)}
                                        style={{ display: 'none' }}
                                    />
                                    
                                    {files.length > 0 ? (
                                        <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                            <span>Uploaded File:</span>
                                            <ul>
                                                {files.map((file, index) => (
                                                <span key={index}>{file.name}</span>
                                                ))}
                                            </ul>
                                            <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                                <button id="add-family" 
                                                className="cancel row"
                                                onClick={()=>clearFiles()}
                                                style={{marginRight:"5px"}}>
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div
                                            id='drop-files-here'
                                            onDrop={(e)=>handleDrop(e)}
                                            onDragOver={(e)=>handleDragOver(e)}
                                            onDragLeave={(e)=>handleDragOut(e)}
                                            style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '5px',
                                            padding: '20px',
                                            marginTop: '10px',
                                            textAlign: 'center',
                                            }}
                                        >
                                            Drop files here
                                        </div>
                                    )
                                }
                                </div>
                            </div>
                            {/* Itinerary */}
                            <div className='itinerary'>
                                <h4 style={{fontWeight:"normal"}}>Itinerary</h4>
                                    <div className="transaction-addBtn row" style={{margin: "10px 0"}}>
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                    </div>
                                <div className="transaction-table container" style={{border: "1px solid #c8c3c3"}}>
                                    <CreateTable
                                        dataList={itineraryList}
                                        setDataList={setItineraryList}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        isItinerayAddState={isItinerayAddState}
                                        setIsItinerayAddState={setIsItinerayAddState}
                                        isItinerayUpdateState={isItinerayUpdateState}
                                        setIsItinerayUpdateState={setIsItinerayUpdateState}
                                        isItinerayDeleteState={isItinerayDeleteState}
                                        setIsItinerayDeleteState={setIsItinerayDeleteState}
                                        itineraryTimeIn={itineraryTimeIn}
                                        setItineraryTimeIn={setItineraryTimeIn}
                                        itineraryTimeOut={itineraryTimeOut}
                                        setItineraryTimeOut={setItineraryTimeOut}
                                        itineraryLocation={itineraryLocation}
                                        setItineraryLocation={setItineraryLocation}
                                        locationData={locationData}
                                    />
                                    {itineraryList && itineraryList.length > 0 ? (
                                        <div></div>
                                    )
                                    :
                                    (
                                        <div>
                                        {loading ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                                <img src={loadingSpinner} alt="Loading..." />
                                            </div>
                                        ) : (
                                                isItinerayAddState || isItinerayUpdateState? <></>
                                                :
                                                <div> {/*<p>No records to display</p>*/}</div>
                                            )
                                        }
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="transaction-form-footer">
                                {CreateButton("dtrCorrection-add-button", "submit", (e)=>submit(e), "SEND REQUEST", "")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <ViewHistoryForm  isOpen={showVieHistoryForm} 
                    onClose={closeViewHistoryForm}
                    user={user}
            >
            </ViewHistoryForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeeId}
                    setEmployee={setEmployee}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function DateInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function TimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="datetime-local"
            id={"time"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function TimeTypeSelect({timeType, setTimeType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setTimeType(event.target.value);
    };

    return (
        <div>
            <select id="timeType" value={timeType} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose Time Type</option>
            <option value="In">Time-In</option>
            <option value="Out">Time-Out</option>
            <option value="NoInOut">No In and No Out</option>
            </select>
        </div>
    );
};
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function ViewHistoryForm({isOpen, 
    onClose,
    user
}){
    var header = [
        "Reference No.",
        "Date",
        "Time Type",
        "Time Rendered",
        "Reason",
        "Reason For Rejection",
        "Date Requested",
        "Uploaded Image",
        "Itinerary",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "date",
        "timeType",
        "timeRendered",
        "reason",
        "reasonForRejection",
        "dateRequested",
        "content",
        "itinerary",
        "status",
    ]

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);
    
    const [showItineraryData, setShowItineraryData] = useState(false);
    const [selectedItinerary, setSelectedItinerary] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/ChangeLogRequest";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/employee/${user.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            setRequests(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen]);

    const handleClose = () => {
        onClose();
    };
    
    const openItinerary = (data) =>{
        console.log(data)
        setSelectedItinerary(data.changeLogItineraries);
        setShowItineraryData(true);
    }
    const closeItinerary = () =>{
        setSelectedItinerary([]);
        setShowItineraryData(false);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>DTR Correction Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                openItinerary={openItinerary}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
            <ViewItineraryForm  isOpen={showItineraryData} 
                    onClose={closeItinerary}
                    data={selectedItinerary}
            >
            </ViewItineraryForm>
        </>
    );
}
function ViewItineraryForm({isOpen, 
    onClose,
    data
}){
    var header = [
        "Time In",
        "Time Out",
        "Location",
    ]
    var accessor = [
        "timeIn",
        "timeOut",
        "location",
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Itinerary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={data}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {data && data.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], 
    setDataList,
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    isItinerayAddState,
    setIsItinerayAddState,
    isItinerayUpdateState,
    setIsItinerayUpdateState,
    isItinerayDeleteState,
    setIsItinerayDeleteState,
    itineraryTimeIn,
    setItineraryTimeIn,
    itineraryTimeOut,
    setItineraryTimeOut,
    itineraryLocation,
    setItineraryLocation,
    locationData,
    openItinerary
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [idCounter, setIdCounter] = useState(0);
    const [recoveredData, setRecoveredData] = useState([]);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const newData = {
        id: idCounter + 1,
        itineraryTimeIn: itineraryTimeIn,
        itineraryTimeOut: itineraryTimeOut,
        itineraryLocation: itineraryLocation,
    }

    const saveAdd = () =>{
        setIdCounter(idCounter + 1);
        setIsItinerayAddState(false);
        setIsItinerayUpdateState(false);
        setDataList(prevDataList => [
            ...prevDataList, 
            newData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const cancelAdd = () =>{
        setIsItinerayAddState(false);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const updateClick = (data) =>{
        setRecoveredData(data);
        setItineraryTimeIn(data.itineraryTimeIn);
        setItineraryTimeOut(data.itineraryTimeOut);
        setItineraryLocation(data.itineraryLocation);
        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );

        setIsItinerayUpdateState(true);
    }
    const cancelUpdate = () =>{
        setIdCounter(idCounter + 1);

        const oldData = {
            id: recoveredData.id,
            itineraryTimeIn: recoveredData.itineraryTimeIn,
            itineraryTimeOut: recoveredData.itineraryTimeOut,
            itineraryLocation: recoveredData.itineraryLocation,
        }

        setDataList(prevDataList => [
            ...prevDataList, 
            oldData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");

        setIsItinerayUpdateState(false);
    }
    const deleteClick = (data) =>{
        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );
    }

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {
                                    column.render("Header")
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {isItinerayAddState ?
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelAdd}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                        :
                        <></>
                    }
                    {isItinerayUpdateState &&
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelUpdate}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            updateClick,
                                            deleteClick,
                                            locationData,
                                            openItinerary)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick, locationData, openItinerary) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Itinerary") {
        return(
            <td>
                <div className="itineary-control row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>openItinerary(data)}><ListIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }

    if( header === "Time In"
    || header === "Time Out"
    ){
        const time = _cell.render("Cell").props.value;

        if (!time) {
            return (
                <td>
                    null
                </td>
            );
        }
    
        let formattedTime = '';
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes('T')) {
            date = new Date(time);
        } else {
            // If the time is not in ISO format, manually create the date
            const currentDate = new Date(); // Get current date for the date portion
            const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
    
            if (isNaN(hours) || isNaN(minutes)) {
                return (
                    <td>
                        Invalid time format
                    </td>
                );
            }
    
            date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
        }
    
        if (isNaN(date.getTime())) {
            return (
                <td>
                    Invalid time format
                </td>
            );
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
            const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            const standardHours = (date.getHours() % 12) || 12; // Convert 0 to 12 for 12-hour format
    
            formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
            formattedTime = `${hours}:${minutes}`;
        }
    
        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if (
        header === "Time Rendered"
      ) {
        const time = _cell.render("Cell").props.value;
    
        if (!time) {
          return <td>-</td>;
        }
    
        let formattedTime = "";
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes("T")) {
          date = new Date(time);
        } else {
          // If the time is not in ISO format, manually create the date
          const currentDate = new Date(); // Get current date for the date portion
          const [hours, minutes] = time
            .split(":")
            .map((part) => parseInt(part, 10));
    
          if (isNaN(hours) || isNaN(minutes)) {
            return <td>Invalid time format</td>;
          }
    
          date = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            hours,
            minutes
          );
        }
    
        if (isNaN(date.getTime())) {
          return <td>Invalid time format</td>;
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
          const amPm = date.getHours() >= 12 ? "PM" : "AM";
          const standardHours = date.getHours() % 12 || 12; // Convert 0 to 12 for 12-hour format
    
          formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
          formattedTime = `${hours}:${minutes}`;
        }
    
        const _date = new Date(_cell.render("Cell").props.value);
    
        const mm = _date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = _date.getDate();
        const yyyy = _date.getFullYear();
    
        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
    
        return <td>{`${formattedDateFrom} ${formattedTime}`}</td>;
      }
    

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
/* function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
          setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        // setLocationId(event.target.value);
        const locationSelect = data.find(info => info.id === parseInt(event.target.value));
        setLocationId(locationSelect.description)
    };

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )
} */
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default DTRCorrection
